
/* MindCoco Image Protection — mc-img-protect.js (L1+L2+L3) */
(function () {
  'use strict';

  var GALLERY_SELECTORS = [
    '.product__section-images',
    '.product-image-container',
    '.product-main-images',
    '.product--image_gallery'
  ].join(', ');

  var WATERMARK_TEXT = 'mindcoco.shop';

  // ── L1: Block right-click on gallery images ──────────────────
  document.addEventListener('contextmenu', function (e) {
    if (e.target.tagName === 'IMG' && e.target.closest(GALLERY_SELECTORS)) {
      e.preventDefault();
      return false;
    }
  }, true);

  // ── L1: Block drag on gallery images ─────────────────────────
  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG' && e.target.closest(GALLERY_SELECTORS)) {
      e.preventDefault();
      return false;
    }
  }, true);

  // ── L2: Inject shield divs ────────────────────────────────────
  function injectShields() {
    document.querySelectorAll('.product-gallery__media-container, .box-ratio').forEach(function (c) {
      if (c.querySelector('.mc-img-shield')) return;
      var shield = document.createElement('div');
      shield.className = 'mc-img-shield';
      shield.addEventListener('contextmenu', function (e) { e.preventDefault(); return false; });
      shield.addEventListener('touchstart', function (e) {
        if (e.touches.length > 1) e.preventDefault();
      }, { passive: false });
      c.appendChild(shield);
    });
  }

  // ── L3: Canvas watermark ──────────────────────────────────────
  function applyWatermark(img) {
    // Skip if already watermarked or image not loaded
    if (img.dataset.mcWatermarked) return;
    if (!img.complete || img.naturalWidth === 0) {
      img.addEventListener('load', function () { applyWatermark(img); }, { once: true });
      return;
    }

    var w = img.naturalWidth;
    var h = img.naturalHeight;

    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    canvas.style.cssText = img.style.cssText;
    canvas.style.width = '100%';
    canvas.style.height = 'auto';
    canvas.style.objectFit = 'contain';
    canvas.style.display = 'block';

    var ctx = canvas.getContext('2d');

    // Draw original image
    try {
      ctx.drawImage(img, 0, 0, w, h);
    } catch (e) {
      // CORS error — skip this image silently
      return;
    }

    // Draw tiled watermark
    ctx.save();
    ctx.translate(w / 2, h / 2);
    ctx.rotate(-0.35); // slight diagonal angle
    ctx.font = 'bold ' + Math.max(14, Math.round(w / 18)) + 'px Arial, sans-serif';
    ctx.fillStyle = 'rgba(255, 255, 255, 0.012)';
    ctx.textAlign = 'center';

    var stepX = Math.max(160, Math.round(w / 3));
    var stepY = Math.max(80, Math.round(h / 5));

    for (var y = -h; y < h * 2; y += stepY) {
      for (var x = -w; x < w * 2; x += stepX) {
        ctx.fillText(WATERMARK_TEXT, x, y);
      }
    }
    ctx.restore();

    // Block right-click on canvas too
    canvas.addEventListener('contextmenu', function (e) { e.preventDefault(); return false; });
    canvas.addEventListener('dragstart', function (e) { e.preventDefault(); return false; });

    // Replace img with canvas in DOM
    img.dataset.mcWatermarked = '1';
    img.style.display = 'none';
    img.parentNode.insertBefore(canvas, img.nextSibling);
  }

  function applyWatermarkToAll() {
    document.querySelectorAll(GALLERY_SELECTORS + ' img').forEach(applyWatermark);
  }

  // ── Init ──────────────────────────────────────────────────────
  function init() {
    injectShields();
    applyWatermarkToAll();
    // Re-run after carousel initialises (Flickity lazy-loads slides)
    setTimeout(function () {
      injectShields();
      applyWatermarkToAll();
    }, 800);
    setTimeout(function () {
      injectShields();
      applyWatermarkToAll();
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
